goog.provide('el8.tourguide.HiliteAction');

goog.require('el8.tourguide.Shade');


/**
 * A widget for Explore (tourguide) which will highlight $elt by surrounding it
 * with opaque Shade objects on all sides.
 */
el8.tourguide.HiliteAction = function(opts) {
    opts = opts || {};
    this._opacity = (opts.opacity === null || opts.opacity === undefined) ?
        0.7 : opts.opacity;
    this._zIndex = (opts.zIndex === null || opts.zIndex === undefined) ?
        1 : opts.zIndex;
};

el8.tourguide.HiliteAction.prototype.show = function($elt, topOffset, buffer, outerBuffer, hideShades) {

    topOffset = topOffset || 0;
    buffer = buffer || {};
    outerBuffer = outerBuffer || {};

    var offsets = $elt.offset();

    var height = $elt.outerHeight(true) || 0;
    var width = $elt.outerWidth(true) || 0;

    var windowHeight = $(window).height();
    var windowWidth = $(window).width() - (outerBuffer.right || 0);

    this._westShade = new el8.tourguide.Shade();
    this._westShade.show(null, {
        'left': 0,
        'top': topOffset,
        'height': windowHeight - topOffset,
        'width': offsets.left - (buffer.left || 0),
        'opacity': this._opacity,
        'zIndex': this._zIndex,
        'backgroundColor': 'black'
    });

    this._eastShade = new el8.tourguide.Shade();
    if (!hideShades || !hideShades['east']) {
        this._eastShade.show(null, {
            'left': offsets.left + width + (buffer.right || 0),
            'top': topOffset,
            'height': windowHeight - topOffset,
            'width': windowWidth - width - offsets.left - (buffer.right || 0),
            'opacity': this._opacity,
            'zIndex': this._zIndex,
            'backgroundColor': 'black'
        });
    }

    this._northShade = new el8.tourguide.Shade();
    this._northShade.show(null, {
        'left': offsets.left - (buffer.left || 0),
        'top': topOffset,
        'height': offsets.top - topOffset - (buffer.top || 0),
        'width': width + (buffer.right || 0) + (buffer.left || 0),
        'opacity': this._opacity,
        'zIndex': this._zIndex,
        'backgroundColor': 'black'
    });

    this._southShade = new el8.tourguide.Shade();
    if (!hideShades || !hideShades['south']) {
        this._southShade.show(null, {
            'left': offsets.left - (buffer.left || 0),
            'top': offsets.top + height + (buffer.bottom || 0),
            'height': windowHeight - height - offsets.top - (buffer.bottom || 0),
            'width': width + (buffer.right || 0) + (buffer.left || 0),
            'opacity': this._opacity,
            'zIndex': this._zIndex,
            'backgroundColor': 'black'
        });
    }

};

el8.tourguide.HiliteAction.prototype.hide = function() {
    if (this._westShade) { this._westShade.hide(); }
    if (this._eastShade) { this._eastShade.hide(); }
    if (this._northShade) { this._northShade.hide(); }
    if (this._southShade) { this._southShade.hide(); }
};

